import { render, staticRenderFns } from "./JobDetailPage.vue?vue&type=template&id=3fa68270&scoped=true"
import script from "./JobDetailPage.vue?vue&type=script&lang=js"
export * from "./JobDetailPage.vue?vue&type=script&lang=js"
import style0 from "./JobDetailPage.vue?vue&type=style&index=0&id=3fa68270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa68270",
  null
  
)

export default component.exports